import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAuthStore } from "../state/authStore";
import MustChangePassword from "../screens/MustChangePassword";
export default function Gate({ children }) {
    const user = useAuthStore((s) => s.user);
    if (user?.mustChangePassword)
        return _jsx(MustChangePassword, {});
    return _jsx(_Fragment, { children: children });
}
